// Acesso ao banco para a autorização de fatura duplicada. A regra pura fica em
// `src/lib/duplicataFatura.ts`.

import { supabase } from '../../src/lib/supabase';
import { faturaEntraNaDuplicata, normalizarUcFatura } from '../../src/lib/duplicataFatura';

export type FaturaDoMes = {
  id: number;
  uc_codigo: string | null;
  mes_referencia: string | null;
  status_fatura: string | null;
  classificacao: string | null;
  cliente_nome: string | null;
  data_vencimento: string | null;
  valor_fatura_distribuidora: number | string | null;
  consumo_ativo_kwh: number | string | null;
  pdf_fatura: string | null;
  created_at: string;
  duplicata_confirmada: boolean | null;
  duplicata_motivo: string | null;
};

/** Faturas da UC naquele mês que o gatilho considera na duplicata (sem avulsa nem inativa). */
export async function buscarFaturasAtivasDoMes(uc: string, mes: string): Promise<FaturaDoMes[]> {
  const norm = normalizarUcFatura(uc);
  if (!norm || !mes.trim()) return [];
  const { data, error } = await supabase
    .from('faturas')
    .select('id, uc_codigo, mes_referencia, status_fatura, classificacao, cliente_nome, data_vencimento, valor_fatura_distribuidora, consumo_ativo_kwh, pdf_fatura, created_at, duplicata_confirmada, duplicata_motivo')
    .eq('uc_codigo_norm', norm)
    .eq('mes_referencia', mes.trim().toUpperCase())
    .order('created_at', { ascending: true });
  if (error) throw error;
  return ((data || []) as FaturaDoMes[]).filter(faturaEntraNaDuplicata);
}

/**
 * Registra a autorização. Ela vale por um dia e para uma única fatura daquela
 * UC + mês — quem consome é o gatilho do banco, na hora do INSERT.
 */
export async function autorizarDuplicata(params: {
  uc: string;
  mes: string;
  motivo: string;
  origem: 'manual' | 'upload_pdf';
  userId?: string | null;
  nome?: string | null;
}): Promise<void> {
  const { error } = await supabase.from('faturas_duplicata_autorizada').insert({
    uc_codigo: params.uc.trim(),
    mes_referencia: params.mes.trim().toUpperCase(),
    motivo: params.motivo.trim(),
    origem: params.origem,
    autorizado_por: params.userId ?? null,
    autorizado_por_nome: params.nome ?? null,
  });
  if (error) throw error;
}

/** Autorizações ainda não usadas e dentro da validade (para a tela avisar). */
export async function autorizacoesEmAberto(uc: string, mes: string): Promise<number> {
  const norm = normalizarUcFatura(uc);
  if (!norm || !mes.trim()) return 0;
  const { count, error } = await supabase
    .from('faturas_duplicata_autorizada')
    .select('id', { count: 'exact', head: true })
    .eq('uc_codigo_norm', norm)
    .eq('mes_referencia', mes.trim().toUpperCase())
    .is('usada_em', null)
    .gt('expira_em', new Date().toISOString());
  if (error) throw error;
  return count || 0;
}
